import { Button, Grid, Text, useToast } from '@afterpaytouch/core'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { useResendEmailCode } from '../../state'
import { TransMaskedText } from '../TransMaskedText'
import { Trans, useTranslation } from '../../utils/convergence'
import { useCheckoutSizes } from '../../utils/responsive'

export const RESEND_COOLDOWN_MS = 30000

interface ResendEmailCodeProps {
  email: string
  disabled: boolean
  onSent: () => void
  onClosed: () => void
}

export const ResendEmailCode: FunctionComponent<ResendEmailCodeProps> = ({ email, disabled, onSent, onClosed }) => {
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  const setToast = useToast()
  const { resend, isSending } = useResendEmailCode()
  const [cooling, setCooling] = useState(true)

  useEffect(() => {
    const timer = cooling ? setTimeout(() => setCooling(false), RESEND_COOLDOWN_MS) : undefined
    return () => clearTimeout(timer)
  }, [cooling])

  const onResend = async (): Promise<void> => {
    const outcome = await resend()
    setCooling(outcome !== 'FAILED')
    if (outcome === 'SENT') {
      onSent()
      setToast({ message: t('verify:codeSent'), kind: 'Success' })
      return
    }
    if (outcome === 'CLOSED') {
      return onClosed()
    }
    if (outcome === 'FAILED') {
      setToast({
        message: () => (
          <Text>
            <Trans
              i18nKey='verify:error.codeSentFail_EMAIL'
              components={{ email: <TransMaskedText actionName='Email Code Resend Email' text={email} testNameSpace='login-email-code-resend-fail-email' /> }}
            />
          </Text>
        ),
        kind: 'Failure',
      })
    }
  }

  return (
    <Grid>
      <Text size={textSize}>
        <Trans
          i18nKey='verify:email.sendLinkStepUp_only'
          components={{
            email: (
              <Button.Link size='Regular' testNameSpace='login-email-code-resend' disabled={disabled || cooling || isSending} onClick={() => void onResend()} />
            ),
          }}
        />
      </Text>
    </Grid>
  )
}
